import { Metamask } from "./metamask"

export const EvmWallets = {
    metamask: Metamask
}